import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const statusColor = {
  paid: "bg-primary/60 text-foreground",
  reserved: "bg-secondary/30 text-foreground",
  pending_payment: "bg-accent/20 text-foreground",
};

export default function Admin() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/bookings`).then((r) => setBookings(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-page" className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border/60 bg-background/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link to="/" className="text-muted-foreground hover:text-foreground flex items-center gap-2"><ArrowLeft size={16}/> Home</Link>
            <h1 className="font-serif text-3xl ml-4">Bookings</h1>
          </div>
          <span className="text-sm text-muted-foreground">{bookings.length} total</span>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        {loading ? (
          <p className="text-muted-foreground">Loading…</p>
        ) : bookings.length === 0 ? (
          <div className="text-center py-20 text-muted-foreground">No bookings yet.</div>
        ) : (
          <div className="overflow-hidden rounded-3xl border border-border/60 bg-card/40">
            <table className="w-full text-sm">
              <thead className="bg-background/60">
                <tr className="text-left text-xs uppercase tracking-[0.16em] text-muted-foreground">
                  <th className="px-5 py-4">Client</th>
                  <th className="px-5 py-4">Service</th>
                  <th className="px-5 py-4">Date</th>
                  <th className="px-5 py-4">Payment</th>
                  <th className="px-5 py-4">Status</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((b) => (
                  <tr key={b.id} className="border-t border-border/40 hover:bg-background/60" data-testid={`booking-row-${b.id}`}>
                    <td className="px-5 py-4">
                      <div className="font-medium">{b.name}</div>
                      <div className="text-muted-foreground text-xs">{b.email} · {b.phone}</div>
                    </td>
                    <td className="px-5 py-4">{b.service_name}<br/><span className="text-muted-foreground text-xs">${b.price}</span></td>
                    <td className="px-5 py-4">{b.preferred_date}<br/><span className="text-muted-foreground text-xs">{b.preferred_time}</span></td>
                    <td className="px-5 py-4 capitalize">{b.payment_option.replace("_", " ")}</td>
                    <td className="px-5 py-4">
                      <Badge className={`${statusColor[b.status] || "bg-muted"} rounded-full px-3 py-1 capitalize`}>{b.status.replace("_", " ")}</Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
